import { createSlice } from '@reduxjs/toolkit';

const getInitialSearchValues = () => {
  if (typeof window !== 'undefined' && window.sessionStorage) {
    try {
      const raw = sessionStorage.getItem('doctolikHomeSearchValue');
      return raw ? JSON.parse(raw) : null;
    } catch {
      return null;
    }
  }
  return null;
};

const initialState = {
  sidebarDrawerOpen: false,
  doctorMsgMobileBarShow: false,
  searchValues: getInitialSearchValues(),
  cookiesValue: null,
  theme: 'light',
  activeModal: null, // { id: string, props?: Record<string, any> }
  activeDrawer: null,
};

export const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    toggleSidebarDrawer: (state) => {
      state.sidebarDrawerOpen = !state.sidebarDrawerOpen;
    },
    setSidebarDrawerOpen: (state, action) => {
      state.sidebarDrawerOpen = Boolean(action.payload);
    },
    setDoctorMsgMobileBarShow: (state, action) => {
      state.doctorMsgMobileBarShow = Boolean(action.payload);
    },
    setSearchValues: (state, action) => {
      state.searchValues = action.payload;
      if (typeof window !== 'undefined' && window.sessionStorage) {
        try {
          if (action.payload) {
            sessionStorage.setItem('doctolikHomeSearchValue', JSON.stringify(action.payload));
          } else {
            sessionStorage.removeItem('doctolikHomeSearchValue');
          }
        } catch (e) {
          console.warn('[Redux UI] Could not save searchValues to sessionStorage:', e);
        }
      }
    },
    setCookiesValue: (state, action) => {
      state.cookiesValue = action.payload;
    },
    setTheme: (state, action) => {
      state.theme = action.payload;
    },
    openModal: (state, action) => {
      state.activeModal = {
        id: action.payload.id,
        props: action.payload.props || {},
      };
    },
    closeModal: (state) => {
      state.activeModal = null;
    },
    openDrawer: (state, action) => {
      state.activeDrawer = {
        id: action.payload.id,
        props: action.payload.props || {},
      };
    },
    closeDrawer: (state) => {
      state.activeDrawer = null;
    },
  },
});

export const {
  toggleSidebarDrawer,
  setSidebarDrawerOpen,
  setDoctorMsgMobileBarShow,
  setSearchValues,
  setCookiesValue,
  setTheme,
  openModal,
  closeModal,
  openDrawer,
  closeDrawer,
} = uiSlice.actions;

// Selectors
export const selectUiState = (state) => state.ui;
export const selectSidebarDrawerOpen = (state) => state.ui.sidebarDrawerOpen;
export const selectDoctorMsgMobileBarShow = (state) => state.ui.doctorMsgMobileBarShow;
export const selectSearchValues = (state) => state.ui.searchValues;
export const selectCookiesValue = (state) => state.ui.cookiesValue;
export const selectTheme = (state) => state.ui.theme;
export const selectActiveModal = (state) => state.ui.activeModal;
export const selectActiveDrawer = (state) => state.ui.activeDrawer;

export default uiSlice.reducer;
